import useJwt from '@src/auth/jwt/useJwt'

// import * as atlas from '@src/api/atlas/order'
// import * as atlasSubscription from '@src/api/atlas/subscription'

import atlasApi from '@src/api/atlas'

import { handleLogout } from '@store/actions/auth'
import { store } from '@store/storeConfig/store'
import axios from 'axios'

const ordersPrefix = '/brands/v2/orders'
useJwt.configLogout(store.dispatch, handleLogout)

// ** GET Products
export const getOrders = (params) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_ORDERS_REQUEST' })
    return useJwt
      .atlas()
      .get(ordersPrefix, {
        params
      })
      .then((res) => {
        dispatch({ type: 'GET_ORDERS', data: res.data, params })
      })
      .catch((err) => {
        dispatch({ type: 'SET_ORDERS_ERROR' })
      })
  }
}

export const setOrders = (orders) => {
  return (dispatch) => {
    return dispatch({ type: 'SET_ORDERS', data: orders })
  }
}

export const getOrder = (orderId, params) => {
  return (dispatch, getState) => {
    if (!params) {
      params = {
        contactId: getState().auth?.userData?.userData?.airtableData?.record_id
      }
    }

    return useJwt
      .atlas()
      .get(ordersPrefix + '/' + orderId, {
        params
      })
      .then((res) => {
        dispatch({ type: 'GET_ORDER', data: res.data, params })
      })
  }
}

export const setOrder = (order, params) => {
  return (dispatch) => {
    return dispatch({ type: 'SET_SELECTED_ORDER', data: order, params })
  }
}

export const setInitialQuantity = (quantity) => {
  return (dispatch) => {
    return dispatch({ type: 'SET_INITIAL_QUANTITY', data: { quantity } })
  }
}

export const setOrderItemChange = (changes, params) => {
  return (dispatch, getState) => {
    return dispatch({
      type: 'SET_CHANGES',
      data: { changes },
      params
    })
  }
}

export const updateItem = (lastChange, params) => {
  return (dispatch, getState) => {
    const orderItems = getState().orders.selectedOrder.items
    const draft = [...orderItems]
    const itemIndex = draft.findIndex(
      (item) => item.record_id === lastChange.id
    )
    draft[itemIndex] = { ...draft[itemIndex], ...lastChange }
    dispatch({
      type: 'UPDATE_ITEM',
      data: { items: draft },
      params
    })

    if (draft.every((item) => item.status === 'Item aprovado')) {
      dispatch(openOrderConfirmationModal(true))
    }
  }
}

export const removeOrderItem = (selectedItem) => {
  return (dispatch, getState) => {
    const order = getState().orders.selectedOrder
    const itemId = selectedItem.record_id
    return useJwt
      .atlas()
      .delete(ordersPrefix + `/${order.record_id}/remove-item/${itemId}`)
      .then((res) => {
        const orderItems = order.items
        const draft = [...orderItems]
        const itemIndex = draft.findIndex(
          (item) => item.record_id === selectedItem.record_id
        )
        draft.splice(itemIndex, 1)
        dispatch({
          type: 'REMOVE_ORDER_ITEM',
          data: { items: draft }
        })
      })
      .catch((err) => {
        return err.response
      })
  }
}

export const addOrderItem = (selectedProductData) => {
  return (dispatch, getState) => {
    const order = getState().orders.selectedOrder
    const productData = getState().ecommerce.productDetail

    // ** Get all details of selected product by user

    const {
      variationId,
      quantity,
      personalizationId,
      personalizationRecordId,
      personalizationImageUrl,
      personalizationColorName,
      personalizationColorId
    } = selectedProductData

    if (productData.variations) {
      const selectedVariation = productData.variations.find(
        (variation) => variation.record_id === variationId
      )
      Object.assign(productData, selectedVariation)
    }
    productData.name = productData.public_id ?? productData.name
    if (productData.price === undefined) {
      productData.price = productData['Preço unitário estimado']
    }
    productData.id = String(productData.id)

    // ** Line item structure for backend insertion

    const lineItem = {
      name: productData.name,
      variation_id: productData.record_id,
      price: productData.price,
      quantity: quantity,
      observations: '',
      personalization: personalizationId,
      personalization_id: personalizationRecordId,
      personalization_image_url: personalizationImageUrl,
      personalization_color: personalizationColorName,
      personalization_color_id: personalizationColorId
    }

    let body = {
      item: lineItem
    }

    return useJwt
      .atlas()
      .post(ordersPrefix + `/${order.record_id}/add-item/`, body)
      .then((res) => {
        const orderItems = order.items
        const draft = [...orderItems]
        const { line_item: createdLineItem } = res.data
        if (createdLineItem && Object.keys(createdLineItem).length > 0) {
          draft.push(createdLineItem)
          dispatch({
            type: 'ADD_ORDER_ITEM',
            data: { items: draft }
          })
        }
      })
      .catch((err) => {
        return err.response
      })
  }
}

export const saveOrderItemChange = (order, changes, params) => {
  return (dispatch, getState) => {
    let client = { ...getState().auth.userData.userData }
    let body = {
      id: changes.id,
      quantity: changes.quantity,
      obs: changes.obs.length === 0 ? '-' : changes.obs,
      mockupUrl: changes.mockupUrl,
      status: 'Mudanças requisitadas',
      createdAt: new Date().toISOString()
    }

    return useJwt
      .atlas()
      .post(ordersPrefix + `/${order.record_id}/add-change`, [body])
      .then((res) => {
        dispatch({
          type: 'SAVE_CHANGES',
          data: {
            id: changes.id,
            quantity: changes.quantity,
            obs: changes.obs.length === 0 ? '-' : changes.obs,
            mockupUrl: changes.mockupUrl,
            createdAt: new Date().toISOString()
          },
          params
        })
        const [changesResponse] = Object.values(res.data)
        const lastChange = changesResponse[changesResponse.length - 1]
        if (lastChange) {
          dispatch(updateItem(lastChange))
        }
      })
  }
}

export const saveOrderMockupChange = (order, changes, params) => {
  return (dispatch, getState) => {
    const body = {
      id: changes.id,
      quantity: changes.quantity,
      obs: changes.obs.length === 0 ? '-' : changes.obs,
      mockupUrl: changes.mockupUrl,
      status: 'Mudanças requisitadas',
      createdAt: new Date().toISOString()
    }
    return useJwt
      .atlas()
      .post(ordersPrefix + `/${order.record_id}/add-change`, [body])
      .then((res) => {
        // dispatch({
        //   type: 'SAVE_CHANGES',
        //   data: {
        //     id: changes.id,
        //     quantity: changes.quantity,
        //     obs: changes.obs.length === 0 ? '-' : changes.obs,
        //     mockupUrl: changes.mockupUrl
        //   },
        //   params
        // })
        dispatch(discardOrderItemChange())
        const [responseChanges] = Object.values(res.data)
        const lastChange = responseChanges[responseChanges.length - 1]
        if (lastChange) {
          dispatch(updateItem(lastChange))
        }
      })
  }
}

export const discardOrderItemChange = () => {
  return (dispatch, getState) => {
    return dispatch({
      type: 'DISCARD_CHANGES'
    })
  }
}

export const approveOrderItem = (order, item, params) => {
  return (dispatch, getState) => {
    const body = {
      id: item.record_id,
      quantity: item.quantity,
      obs: '-',
      status: 'Mockup sendo criado',
      mockupUrl: [],
      createdAt: new Date().toISOString()
    }

    return useJwt
      .atlas()
      .post(ordersPrefix + `/${order.record_id}/add-change`, [body])
      .then((res) => {
        dispatch({
          type: 'APPROVE_ORDER'
        })
        const [changes] = Object.values(res.data)
        const lastChange = changes[changes.length - 1]
        if (lastChange) {
          dispatch(updateItem(lastChange))
        }
      })
  }
}

export const approveOrderMockup = (order, item, params) => {
  return (dispatch, getState) => {
    let client = { ...getState().auth.userData.userData }
    let body = {
      id: item.record_id,
      quantity: item.quantity,
      obs: '-',
      mockupUrl: [],
      status: 'Item aprovado'
    }

    return useJwt
      .atlas()
      .post(ordersPrefix + `/${order.record_id}/approve-item`, body)
      .then((res) => {
        dispatch({
          type: 'APPROVE_ORDER'
        })
        const approvedLineItem = res.data
        if (approvedLineItem) {
          dispatch(updateItem(approvedLineItem))
        }
        // const [changes] = Object.values(res.data)
        // const lastChange = changes[changes.length - 1]
        // if (lastChange) {
        //   dispatch(updateItem(lastChange))
        // }
      })
  }
}

export const getProposal = (orderId) => {
  return async (dispatch, getState) => {
    const res = await axios.get(
      `https://proxy.beuni.com.br/api/proposal/${orderId}`
    )

    const proposalData = res.data

    const totalItems = proposalData.items.length
    const totalQuantity = proposalData.items.reduce((acc, item) => {
      return acc + Number(item.quantity)
    }, 0)
    const totalOther = 0
    const totalItemsPrice = proposalData.items.reduce((acc, item) => {
      return acc + Number(item.total_price)
    }, 0)
    const shipping = proposalData.shipping ?? 0

    const orderDiscount = proposalData.order_discount
    const typeDiscount = proposalData.type_discount
    const finalDiscount = proposalData.final_discount || null

    const totalProposal = proposalData.total_proposal
    const finalTotal = proposalData.total

    const commercialObservation = proposalData.commercial_observation ?? ''
    const formattedCommercialObservation = commercialObservation.split(/\r?\n/)

    const proposal = {
      ...proposalData,
      formattedCommercialObservation,
      subscription: {
        ...proposalData.assignedSubscription
      },
      totals: {
        totalItems,
        totalQuantity,
        totalOther,
        totalItemsPrice,
        shipping,
        totalProposal,
        orderDiscount,
        typeDiscount,
        finalDiscount,
        finalTotal
      }
    }

    dispatch({
      type: 'GET_PROPOSAL',
      data: { proposal }
    })

    //   return useJwt
    //     .atlas()
    //     .get(
    //       `${ordersPrefix}/${orderId}/proposal`,
    //       { body },
    //       { params: { clientId } }
    //     )
    //     .then((res) => {
    //       const totalItems = res.data.items.length
    //       const totalQuantity = res.data.items.reduce((acc, item) => {
    //         return acc + Number(item.quantity)
    //       }, 0)
    //       const totalOther = 0
    //       const totalItemsPrice = res.data.items.reduce((acc, item) => {
    //         return acc + Number(item.total_price)
    //       }, 0)
    //       const shipping = res.data.shipping ?? 0

    //       const orderDiscount = res.data.order_discount
    //       const typeDiscount = res.data.type_discount
    //       const finalDiscount = res.data.final_discount || null

    //       const totalProposal = res.data.total_proposal
    //       const finalTotal = res.data.total

    //       const commercialObservation = res.data.commercial_observation ?? ''
    //       const formattedCommercialObservation =
    //         commercialObservation.split(/\r?\n/)

    //       const proposal = {
    //         ...res.data,
    //         formattedCommercialObservation,
    //         totals: {
    //           totalItems,
    //           totalQuantity,
    //           totalOther,
    //           totalItemsPrice: `R$ ${totalItemsPrice
    //             .toFixed(2)
    //             .replace('.', ',')}`,
    //           shipping: `R$ ${shipping.toFixed(2).replace('.', ',')}`,
    //           totalProposal: `R$ ${totalProposal.toFixed(2).replace('.', ',')}`,
    //           orderDiscount,
    //           typeDiscount,
    //           finalDiscount,
    //           finalTotal
    //         }
    //       }

    //       dispatch({
    //         type: 'GET_PROPOSAL',
    //         data: { proposal }
    //       })
    //     })
    //     .catch((err) => {
    //       console.error(err.message)
    //     })
  }
}

// ** Order confirmation modal

export const openOrderConfirmationModal = (boolean = false) => {
  return (dispatch) => {
    dispatch({
      type: 'OPEN_ORDER_CONFIRMATION_MODAL',
      data: { boolean }
    })
  }
}

export const setLogisticsData = (logisticsData) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_LOGISTICS_DATA',
      data: { logistic: logisticsData }
    })
  }
}

export const setFullfillData = (fullfillData) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_FULLFILL_DATA',
      data: { payment: fullfillData.payment, logistic: fullfillData.logistic }
    })
  }
}

export const setInvoicingData = (invoicingData) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_INVOICING_DATA',
      data: {
        company: invoicingData.company,
        address: invoicingData.address,
        contact: invoicingData.contact
      }
    })
  }
}

export const setObservationData = (observations) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_OBSERVATION_DATA',
      data: { observations }
    })
  }
}

export const confirmOrderRequest = (orderId) => {
  return async (dispatch, getState) => {
    const { logistic, payment, observations } = getState().orders.confirm

    const body = {
      // status: 'Aguardando pagamento',
      logistics: {
        option: logistic?.option?.id,
        shipping_deadline: logistic?.shippingDeadline
      },
      payment: {
        method: payment?.option?.id,
        due_date: payment?.paymentDeadline
      },
      observations
    }

    try {
      const response = await atlasApi.order.confirmOrder(orderId, body)
      dispatch(setOrder(response.data))
      return response
    } catch (err) {
      console.error(err)
      return err.response
    }
  }
}

// ** Timeline tracking view toggle

export const toggleTimelineView = (boolean = false) => {
  return (dispatch) => {
    dispatch({
      type: 'TOGGLE_TIMELINE_VIEW',
      data: { boolean }
    })
  }
}
